import React, { useEffect, useState } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ModalBodyBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../../features/RadConnStyle";
import styled from "styled-components";

import { PageOptions } from "../../components/PageParams";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import BoostrapTable from "react-bootstrap-table-next";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import { GetConfirmTitle } from "../../components/ConfirmDialog";

export default function GoodsUnit(props) {
  const [data, setData] = useState([]);
  const [filterText, setFilterText] = useState(null);
  const [reload, setReload] = useState(true);
  const commonNonBorder = () => {
    return { border: "none", color: "var(--table-text-color)" };
  };

  useEffect(() => {
    if (reload) {
      loadList();
      setReload(false);
    }
  }, [reload]);

  // ********** RELOAD *********
  const loadList = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/goods/list-goodunits",
        { text: "ok" },
        HttpJsonHeader
      )
      .then((response) => {
        setData(response.data.GoodsUnits);
      })
      .catch((err) => alert(err));
  };

  // ********** ADDNEW **********
  const doAddNew = () => {
    let saveData = {
      GoodUnitId: -1,
      GoodUnitName: filterText,
      CreatedBy: props.user.userid,
    };
    axios
      .post(
        process.env.REACT_APP_API + "api/goods/list-goodunits-save",
        saveData,
        HttpJsonHeader
      )
      .then((res) => {
        setReload(true);
      })
      .catch((err) => console.log(err));
  };

  //  ********** Update Data **********
  const beforeSaveCell = (oldValue, newValue, row, column, done) => {
    if (oldValue === newValue) {
      // alert("It Equal!!!");
      done(false);
      return;
    }

    let saveData = {
      GoodUnitId: row.itemId,
      GoodUnitName: newValue,
      UpdatedBy: props.user.userid,
    };

    props.setShowConfirm(true);
    props.setConfirmAction({
      title: GetConfirmTitle("UPDATE"),
      data: saveData,
      action: (data) => {
        axios
          .post(
            process.env.REACT_APP_API + "api/goods/list-goodunits-save",
            data,
            HttpJsonHeader
          )
          .then((res) => {
            setReload(true);
          })
          .catch((err) => console.log(err));
      },
    });
  };

  // ********** Delete **********
  const popupDelete = (row) => {
    props.setShowConfirm(true);
    props.setConfirmAction({
      title: GetConfirmTitle("DELETE"),
      data: row,
      action: (row) => {
        axios
          .post(
            process.env.REACT_APP_API + "api/goods/goodsunit-delete",
            { GoodUnitID: row.itemId, DeletedBy: props.user.userid },
            HttpJsonHeader
          )
          .then((res) => {
            setReload(true);
          })
          .catch((err) => console.log(err));
      },
    });
  };

  const formatEditBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ลบ</Tooltip>}
        >
          <Button
            variant="danger"
            className="info-button"
            onClick={() => {
              popupDelete(row);
            }}
          >
            <AiOutlineDelete />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };

  const headerBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>บันทึก</Tooltip>}
        >
          <Button
            variant="info"
            className="info-button"
            onClick={() => doAddNew()}
          >
            <AiOutlinePlus />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };

  //  ********** Column **********
  const columns = [
    {
      dataField: "itemName",
      text: "หน่วยนับ",
      sort: true,
      style: commonNonBorder,
      align: "center",
      filter: textFilter({
        onFilter: (filterValue) => {
          setFilterText(filterValue);
        },
      }),
      editor: { type: Type.TEXT },
      headerStyle: () => {
        return {
          border: "none",
          borderRadius: "1px 0 0 0",
          overflow: "hidden",
          color: "#cccccc",
          align: "center",
          backgroundImage: "linear-gradient(#212122,  #38383a, #2d2d2e)",
        };
      },
    },
    {
      dataField: null,
      text: "",
      headerStyle: () => {
        return { width: "54px" };
      },
      align: "center",
      editable: false,
      formatter: formatEditBox,
      headerFormatter: headerBox,
    },
  ];

  return (
    <MyModal
      backdrop="static"
      show={props.showGoodUnit}
      size="sm"
      style={{ padding: "0px", margin: "0px" }}
      onHide={() => {
        props.setShowGoodUnit(false);
      }}
    >
      <ModalHeaderBlack closeButton></ModalHeaderBlack>
      <ModalBodyBlack>
        <MainPane>
          <LeftPane>
            <BoostrapTable
              bootstrap4
              keyField="itemId"
              data={data}
              columns={columns}
              striped
              hover
              condensed
              rowClasses={"table-next-rows-style"}
              headerWrapperClasses="headerWrapper"
              // wrapperClasses="bs-table-wrapper"
              // bordered={ true }
              filter={filterFactory()}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                beforeSaveCell: beforeSaveCell,
              })}

              // pagination = {paginationFactory( PageOptions)}
              // rowStyle = {rowStyle2}
              // rowEvents= {rowEvents}
            />
          </LeftPane>

          <RightPane></RightPane>
        </MainPane>
      </ModalBodyBlack>
    </MyModal>
  );
}

const MainPane = styled.div`
  display: flex;
  justify-content: center;
  min-height: 80vh;
  /* max-height: 80vh; */
  /* overflow-y: scroll; */

  /* background-color:red; */
`;

const LeftPane = styled.div``;

const RightPane = styled.div``;
